import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const LowBalanceAlertModal = ({ show, handleClose, mode, alertData, onSave }) => {
  const [formData, setFormData] = useState({
    apiProvider: '',
    thresholdAmount: '',
    currentBalance: '',
    mobile: '',
    email: ''
  });

  useEffect(() => {
    if (mode === 'edit' && alertData) {
      setFormData(alertData);
    } else {
      setFormData({
        apiProvider: '',
        thresholdAmount: '',
        currentBalance: '',
        mobile: '',
        email: ''
      });
    }
  }, [mode, alertData, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {mode === 'add' ? 'Add Low Balance Alert' : 'Edit Low Balance Alert'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>API Provider <span className="text-danger">*</span></Form.Label>
                <Form.Select
                  name="apiProvider"
                  value={formData.apiProvider}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select API Provider</option>
                  <option value="RupeeBiz API 1">RupeeBiz API 1</option>
                  <option value="RupeeBiz API 2">RupeeBiz API 2</option>
                  <option value="PayTM Gateway">PayTM Gateway</option>
                  <option value="Airtel Payment API">Airtel Payment API</option>
                  <option value="Jio Money API">Jio Money API</option>
                  <option value="PhonePe API">PhonePe API</option>
                  <option value="Razorpay API">Razorpay API</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Threshold Amount <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="number"
                  name="thresholdAmount"
                  value={formData.thresholdAmount.replace('₹', '')}
                  onChange={(e) => setFormData(prev => ({ ...prev, thresholdAmount: `₹${e.target.value}` }))}
                  placeholder="1000"
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Current Balance</Form.Label>
                <Form.Control
                  type="number"
                  name="currentBalance"
                  value={formData.currentBalance.replace('₹', '')}
                  onChange={(e) => setFormData(prev => ({ ...prev, currentBalance: `₹${e.target.value}` }))}
                  placeholder="15000"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Mobile Number <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="tel"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="+91 1234567890"
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Email <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="alert@Shakti E Solution.com"
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button 
              variant="secondary" 
              onClick={handleClose}
              className="btn-outline-danger-custom"
            >
              Cancel
            </Button>
            <Button 
              type="submit"
              className="btn-outline-primary-custom"
            >
              {mode === 'add' ? 'Add Alert' : 'Update Alert'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default LowBalanceAlertModal;

